import http from "./constants/http";
import resources from "./constants/resources";
import axios from "axios";
import FormData from "form-data";

export const varListDummy = async () => {
  const body = {
    modes: "VarList",
  };
  const res = await http(resources.DUMMY).post(body);

  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};

export const varListTestDummySSR = async () => {
  const formData = new FormData();
  formData.append("modes", "VarList");

  // 헤더 없이 전송 시도 (서버에서 token 불필요하니까)
  try {
    const response = await axios.post(
      "https://api.caretbio.com/api/store/DefaultArray",
      formData,
      {
        headers: formData.getHeaders(),
      }
    );
    return response;
  } catch (e) {
    console.error("SSR 요청 실패:", e);
    return e;
  }
};

export const postDefaultArray = async (body) => {
  const res = await http(resources.DUMMY).post(body);

  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};
